module.exports = "Your join request to Group <simple-link target=\"task.target\"></simple-link> was approved.";